module.exports = __webpack_public_path__ + "static/media/1.53fb8a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/10001/1.jpg
// module id = 403
// module chunks = 0